import type { LoginScreenConfig } from "../types/loginScreen";

const CACHE_KEY = "polaris.loginScreen.v1";

export type CachedLoginScreen = Pick<LoginScreenConfig, "heroImageUrl" | "backgroundColor" | "tagline">;

export function readLoginScreenCache(): CachedLoginScreen | null {
    try {
        const raw = sessionStorage.getItem(CACHE_KEY);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw) as CachedLoginScreen;
        if (!parsed.heroImageUrl?.trim()) {
            return null;
        }
        return parsed;
    } catch {
        return null;
    }
}

export function writeLoginScreenCache(config: LoginScreenConfig | null): void {
    if (!config?.heroImageUrl?.trim()) {
        return;
    }
    try {
        const payload: CachedLoginScreen = {
            heroImageUrl: config.heroImageUrl,
            backgroundColor: config.backgroundColor,
            tagline: config.tagline,
        };
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(payload));
    } catch {
        /* sessionStorage full or disabled */
    }
}

export function cachedLoginScreenToConfig(cached: CachedLoginScreen): LoginScreenConfig {
    return {
        id: 0,
        slug: "session-cache",
        heroImageUrl: cached.heroImageUrl,
        backgroundColor: cached.backgroundColor,
        tagline: cached.tagline,
    };
}
